import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PayrollRoutingModule } from './payroll-routing.module';
import { AttendanceComponent } from './attendance/attendance.component';
import { PipeModuleModule } from '../pipe/pipe-module/pipe-module.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';

@NgModule({
  declarations: [AttendanceComponent],
  imports: [
    CommonModule,
    PayrollRoutingModule,
    PipeModuleModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatTableModule
  ]
})


export class PayrollModule { }
